import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PgTerminationRequest, Policy, PolicyPg} from '../models/policy.model';
import {Attachment} from '../models/attachment.model';
import {SearchQueryParams} from '../models/search-query-params.model';
import {mapSearchListResponse} from '../helpers/search.helper';
import {SystemFile} from '../models/system-file.model';
import {
    Amendment,
    AmendmentConfigurationType,
    AmendmentCpiBeneficiaryChange,
    AmendmentCpiPersonalData,
    AmendmentCpiTermination
} from '../models/amendment.model';
import {DictionaryItem} from '../models/dictionary.model';


@Injectable()
export class PolicyService {

    baseUrl = '/api/secured/policy';
    salesBaseUrl = '/api/secured/sales/pg';

    constructor(private http: HttpClient) {
    }

    getPolicy(policyId: number) {
        return this.http.get<Policy>(`${this.baseUrl}/${policyId}`);
    }

    printout(policyId: number, single: boolean = false) {
        const url = single
            ? `${this.baseUrl}/${policyId}/printout/policy-single`
            : `${this.baseUrl}/${policyId}/printout/policy`;
        return this.http.get<{ token: string }>(url);
    }

    duplicate(policyId: number) {
        return this.http.get<{ token: string }>(`${this.baseUrl}/${policyId}/printout/duplicate`);
    }

    getAttachments(policyId: number) {
        return this.http.get<Attachment[]>(`${this.baseUrl}/${policyId}/attachment`);
    }

    createAttachment(policyId: number, file: SystemFile) {
        return this.http.post<Attachment[]>(`${this.baseUrl}/${policyId}/attachment`, {hash: file.hash});
    }

    fetchList(props: SearchQueryParams) {
        return this.http
            .get(this.baseUrl, {params: props.getHttpParams(), observe: 'response'})
            .pipe(mapSearchListResponse<Policy>(Policy));
    }

    cancellation(policyId: number) {
        const data = {configurationType: AmendmentConfigurationType.CPI_CANCELLATION};
        return this.http.post<Amendment>(`${this.baseUrl}/${policyId}/amendment/cancel`, data);
    }

    getTerminationReasons(policyId: number) {
        return this.http.get<DictionaryItem[]>(`${this.baseUrl}/${policyId}/terminate-reasons`);
    }

    termination(policyId: number, data: AmendmentCpiTermination) {
        return this.http.post<Amendment>(`${this.baseUrl}/${policyId}/amendment/terminate`, data);
    }

    beneficiaryChange(policyId: number, data: AmendmentCpiBeneficiaryChange) {
        return this.http.post<Amendment>(`${this.baseUrl}/${policyId}/amendment/beneficiary`, data);
    }

    personalChange(policyId: number, data: AmendmentCpiPersonalData) {
        return this.http.post<Amendment>(`${this.baseUrl}/${policyId}/amendment/personal-data`, data);
    }

    confirmPayment(policyId: number) {
        return this.http.post<PolicyPg>(`${this.salesBaseUrl}/${policyId}/confirm-payment`, {});
    }

    pgCancellation(policyId: number) {
        return this.http.post<PolicyPg>(`${this.salesBaseUrl}/${policyId}/cancel`, {});
    }

    pgTermination(policyId: number, payload: PgTerminationRequest) {
        return this.http.post<PolicyPg>(`${this.salesBaseUrl}/${policyId}/terminate`, payload);
    }
}

